import { createMockListResponse as s } from "../../../helpers/CreateMockListResponse.js";
const r = (e = 0, t = 200) => ({
  id: `dataset-${e}`,
  name: `Dataset ${e}`,
  queries: Array.from({ length: t }, (o, a) => ({ text: `Sample query text ${a}` }))
}), n = s(r);
export {
  r as createMockBatchAnswerDataset,
  n as createMockBatchAnswerDatasetListResponse
};
//# sourceMappingURL=BatchAnswerDatasets.mocks.js.map
